export const environment = {
  name: 'dev',
  production: false,
  apiBaseUrl: 'https://apidev.humandome.2tci.nl',
  //apiBaseUrl: 'http://192.168.178.157:5079',
} as const;
